import * as React from "react";
import { Modal } from "antd";

interface contactModalProps {
  visible: boolean;
  afterClose: () => void;
}

const ContactModal: React.FC<contactModalProps> = ({ visible, afterClose }) => {
  return (
    <Modal
      title="联系我们"
      footer={null}
      width={300}
      onCancel={afterClose}
      visible={visible}
      centered
    >
      <p>视频会议 18611385915</p>
    </Modal>
  );
};

export default ContactModal;
